import { render, staticRenderFns } from "./Production.vue?vue&type=template&id=f388288e&scoped=true"
import script from "./Production.vue?vue&type=script&lang=js"
export * from "./Production.vue?vue&type=script&lang=js"
import style0 from "./Production.vue?vue&type=style&index=0&id=f388288e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f388288e",
  null
  
)

export default component.exports